import { Injectable } from '@angular/core';
import { BaseService } from '@services/base-service.service';
import {
  IDetailRewardSetting,
  IPayloadAddProductReward,
  IPayloadCreateReward,
  IProductRewardSetup,
  IReward_ResponseCreate,
  IRewardPeriode,
  IRewardProductPeriode,
} from './reward-setting.interface';
import { API } from '@config/constants/api.constant';
import { RewardSettingStatus } from '@config/enum/reward-setting.enum';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { ISelectPeriode } from '@shared/components/form/input-select-material/input-select-material.interface';

@Injectable({
  providedIn: 'root',
})
export class RewardSettingService {
  constructor(private baseService: BaseService) {}

  getYears(dateString : string) {
    const dates = dateString.toString();
    const [dd, mm, yyyy] = dates.split('-');
    const dateObj = new Date(`${yyyy}-${mm}-${dd}`);
    const years = dateObj.getFullYear();
    return 'Periode ' + years.toString()
  }

  getInitialDetailReward(id: string) {
    return this.baseService.getData<IDetailRewardSetting>(API.DETAIL_HEADER_REWARD_SETTING + id).pipe(
      map((resp) => {
        return resp;
      })
    );
  }

  getInitialRewardPeriode(brandId: string) {
    return this.baseService.getData<IProductRewardSetup>(API.INITIAL_REWARD_PERIODE + brandId);
  }

  getListPeriode() {
    return this.baseService.getData<IRewardPeriode[]>(API.LIST_CREATE_PERIODE);
  }

  getListBrandPeriode(periodeID: string) {
    return this.baseService.getData<IRewardProductPeriode[]>(API.LIST_BRAND_BY_PERIODE + periodeID).pipe(
      shareReplay(),
      map((resp) => resp && resp.data)
    );
  }

  createPeriodeReward(payloadData: IPayloadCreateReward) {
    const { periode_id, list_brand, document } = payloadData;
    return this.baseService.postData<IReward_ResponseCreate>(API.CREATE_REWARD_PERIODE + periode_id, {
      list_brand,
      document,
    });
  }

  addProductReward(payloadData: IPayloadAddProductReward) {
    const { brand_id, periode_id, document, qty } = payloadData;
    const payload = {
      period_id: periode_id,
      qty,
      document,
    };
    return this.baseService.postData<IPayloadAddProductReward>(API.ADD_PRODUCT_REWARD + brand_id, payload);
  }

  getPeriodeStatusColor(enumStatus: string) {
    return enumStatus === RewardSettingStatus.PENDING ? 'text-secondary-orange' : enumStatus === RewardSettingStatus.ACTIVE ? 'text-secondary-blue' : 'text-primary';
  }

  mapInputSelectPeriode(data: IRewardPeriode[]) {
    return data.map((resp) => {
      const inputSelector = new ISelectPeriode();
      inputSelector.setPeriodeOptions(resp);
      inputSelector.labelExtra = `<span class="ms-3 text-capitalize fw-bold ${this.getPeriodeStatusColor(resp.status_enum)}">${resp.status_string}</span>`;
      return inputSelector;
    });
  }
}
